import type { User } from 'firebase/auth';

export function useFirebaseTokenExchange() {
  const loading = ref(false);
  const error = ref<string | null>(null);

  const exchangeToken = async(userOrToken: User | string) => {
    loading.value = true;
    error.value = null;

    try {
      let firebaseToken: string;

      if (typeof userOrToken === 'string') {
        firebaseToken = userOrToken;
      } else {
        firebaseToken = await userOrToken.getIdToken(true);
      }

      return await performTokenExchange(firebaseToken, 0);
    } catch (err) {
      const message
                = err instanceof Error
                  ? err.message
                  : 'Token exchange failed';

      error.value = message;
      console.error('[Token Exchange Error]', err);
      throw err;
    } finally {
      loading.value = false;
    }
  };

  const performTokenExchange = async(firebaseToken: string, attemptNumber: number): Promise<any> => {
    try {
      return await $fetch('/auth/firebase/exchange', {
        method: 'POST',
        credentials: 'include',
        body: {
          token: firebaseToken,
        },
      });
    } catch (err) {
      const isForbidden = err instanceof Error && err.message.includes('403');

      if (isForbidden && attemptNumber < 2) {
        const delayMs = 300 * (attemptNumber + 1);
        await new Promise(resolve => setTimeout(resolve, delayMs));
        return performTokenExchange(firebaseToken, attemptNumber + 1);
      }

      throw err;
    }
  };

  return {
    exchangeToken,
    loading: readonly(loading),
    error: readonly(error),
  };
}
